import {snowplowTrackEvent} from "utils/snowplow";
import UTIF from "utif";
import * as Api from 'utils/api/api.js';
import {UID_TYPES} from "utils/constants";


const HTML_MIME_TYPE = "text/html";
const APPLICATION_HTML_MIME_TYPE = "application/html";
const TIFF_MIME_TYPE = "image/tiff";

export async function fetchAttachmentBlob(url: string, mimeType: string, userData: any, uid: string | null, docVersion: string | number | null, docId: Array<number> | number | string): Promise<string | null> {

    let objectURL: string = "";
    let startTime = new Date().getTime();

    try {
        let attachmentBlob: Blob | undefined = undefined;

            if (!uid || uid === "") {
                console.log("No URL provided for fetching attachment.");
                return null;
            }
            let approvalResponse = null;
            if (uid?.includes(UID_TYPES.TASK)) {
                approvalResponse = await Api.getTaskAttachments(uid, docId);
            } else if (uid?.includes(UID_TYPES.DOCUMENT)) {
                approvalResponse = await Api.getDocumentAttachments(uid, docId, docVersion);
            } else if (uid?.includes(UID_TYPES.PROCESS)) {
                approvalResponse = await Api.getProcessAttachments(uid, docId);
            }
            if(approvalResponse?.urls[0].error) {
                throw new Error(`Error fetching attachment URL: ${approvalResponse?.urls[0].error}`);
            }

            let apiStorageUrl = getUrlWithCorsParameter(approvalResponse?.urls[0].url);

            let dataStorageReply = await fetch(apiStorageUrl);
            attachmentBlob = await dataStorageReply?.blob();




        if (attachmentBlob) {
            if (attachmentBlob.type === TIFF_MIME_TYPE) {
                let arrayBufferTiff = await attachmentBlob.arrayBuffer();
                let decodedTiff = UTIF.decode(arrayBufferTiff);
                UTIF.decodeImage(arrayBufferTiff, decodedTiff[0]);
                let imageObject = await UTIF.toRGBA8(decodedTiff[0]);
                imageObject.width = decodedTiff[0].width;
                imageObject.height = decodedTiff[0].height;

                return imageObject;
            } else {
                const encodedBlob = (mimeType === HTML_MIME_TYPE || mimeType === APPLICATION_HTML_MIME_TYPE) ? new Blob([attachmentBlob], {type: HTML_MIME_TYPE + ';charset=utf-8'}) : attachmentBlob;
                objectURL = URL.createObjectURL(encodedBlob);
            }
        }

    } catch (error) {
        if (error instanceof Error)
            console.log("Could not get the attachments url " + error.message);
        throw error;
    }
    let stopTime = new Date().getTime();
    let total = ((stopTime - startTime) / 1000).toString() || "unknown";

    snowplowTrackEvent({
        category: "bypass-cir",
        action: "fetch-attachment",
        label: "fetch-attachment",
        value: total
    }, userData);

    return objectURL;
}

function getUrlWithCorsParameter(url: string | undefined): string | undefined {
    let apiStorageUrl = url;
    if (typeof apiStorageUrl === "string") {
        try {
            const hostname = new URL(apiStorageUrl).hostname;
            if (hostname.endsWith(".vismaonline.com")) {
                apiStorageUrl += "?corsOrigin=" + encodeURIComponent(window.location.origin);
            }
        } catch (e) {
            // Invalid URL, do nothing
        }
    }
    return apiStorageUrl;
}

export default fetchAttachmentBlob
